var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.01 53.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0b65ff;}.cls-2{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "wppRecurso 41") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1-2",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M26.5,52.51a26,26,0,1,1,26-26A26,26,0,0,1,26.5,52.51Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M26.5,1A25.51,25.51,0,1,1,1,26.5,25.51,25.51,0,0,1,26.5,1m0-1A26.51,26.51,0,1,0,53,26.5,26.53,26.53,0,0,0,26.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12,41c.15-.56.29-1.06.42-1.57.52-1.87,1-3.74,1.54-5.6a.81.81,0,0,0-.07-.63,14.22,14.22,0,0,1-1.62-9.06,13.54,13.54,0,0,1,2.65-6.44,14.06,14.06,0,0,1,11.94-5.94,13.9,13.9,0,0,1,12,6.73,13.78,13.78,0,0,1,1.53,12.29A14,14,0,0,1,30.93,40a14.14,14.14,0,0,1-10.4-.64h0a2,2,0,0,0-1.92-.17c-2.1.59-4.21,1.12-6.32,1.67Zm3.49-3.46.4-.08c1.18-.31,2.37-.61,3.54-.94a1.38,1.38,0,0,1,1.17.16,11.59,11.59,0,0,0,8.05,1.46,12,12,0,0,0,10-12.91A11.64,11.64,0,0,0,34,16.68,11.88,11.88,0,0,0,20,16.11a11.72,11.72,0,0,0-5.49,9.76,11.59,11.59,0,0,0,1.95,6.94.66.66,0,0,1,.09.58C16.21,34.74,15.84,36.08,15.46,37.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.35,32.76c-3.93-1.26-6.28-3.71-8.34-7.13a4.82,4.82,0,0,1-.66-3.74,4.18,4.18,0,0,1,1.29-2.07,1.38,1.38,0,0,1,1-.31c1.07,0,1.11,0,1.5,1,.29.71.55,1.44.89,2.13A1.14,1.14,0,0,1,23.83,24c-.21.27-.44.53-.67.78a.57.57,0,0,0-.08.75,9.86,9.86,0,0,0,5,4.3.57.57,0,0,0,.71-.17c.36-.46.75-.9,1.1-1.37a.55.55,0,0,1,.74-.23c1,.48,2,1,3.06,1.48A.62.62,0,0,1,34,30a2.73,2.73,0,0,1-1.23,2.48,3.88,3.88,0,0,1-2.33.7A17.74,17.74,0,0,1,28.35,32.76Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappBlue);
export default __webpack_public_path__ + "static/media/whatsapp-blue.fdce22fd7f7aaeadfbe7f85023a4938f.svg";
export { ForwardRef as ReactComponent };